export default "__VITE_ASSET__DpehT8x5__"